import React from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, Lock, ArrowRight } from "@phosphor-icons/react";

export default function Handoff() {
  const { token } = useParams();
  const [payload, setPayload] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    api.get(`/leads/decode/${token}`)
      .then((r) => setPayload(r.data))
      .catch(() => setError("Invalid or expired payload token"));
  }, [token]);

  return (
    <div className="min-h-screen bg-background grid place-items-center p-6 grid-bg">
      <div className="w-full max-w-2xl border border-white/[0.08] bg-[#0a0a0a] rounded-sm p-8 relative">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 border border-primary grid place-items-center primary-glow">
            <Lock size={16} className="text-primary" />
          </div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.24em] text-muted-foreground">Secure handoff</div>
            <div className="font-heading font-bold text-lg">Main Site Intake · Payload Received</div>
          </div>
        </div>

        {error && (
          <div className="mt-6 text-sm text-destructive font-mono">{error}</div>
        )}

        {payload && (
          <>
            <div className="mt-6 flex items-center gap-2 text-success text-sm">
              <CheckCircle size={16} weight="fill" /> Encrypted payload decoded successfully.
            </div>
            <pre className="mt-4 bg-[#050505] border border-white/[0.06] rounded-sm p-4 text-xs font-mono overflow-x-auto">{JSON.stringify(payload, null, 2)}</pre>
            <div className="mt-6 text-xs text-muted-foreground">
              This mock endpoint simulates the receiving side of the DW Mortgage Hub → main lending intake bridge.
              The main site would parse this payload and pre-fill the borrower's application state.
            </div>
          </>
        )}

        <div className="mt-8 flex items-center justify-between border-t border-white/[0.06] pt-6">
          <span className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">DW Mortgage Hub · Secure bridge</span>
          <Link to="/app/leads" className="inline-flex items-center gap-1 text-xs text-primary hover:opacity-80">Back to pipeline <ArrowRight size={12} /></Link>
        </div>
      </div>
    </div>
  );
}
